//====================================================
// Demande actions enum
//====================================================
export const EntreeFormationActions = {
    ACCESS: 'access',
};
//# sourceMappingURL=entree-formation.js.map